import { Dialog as MuiDialog, styled } from "@mui/material";

// Shared look of the header's popups — the connect-wallet dialog and the
// "Authenticate to continue" sheet (Header/UserAccount) and the search
// no-results dialog (Header/SearchNoResultsDialog): a white 18px-radius card
// with a floating icon badge over its top edge, centred title, grey subtitle.

export const DialogInfo = styled(MuiDialog)`
  .MuiDialog-paper {
    max-width: 40%;
    min-width: 300px;
    background-image: none;
    border-radius: 18px;
    position: relative;
    overflow: visible;
    border: 1px solid ${({ theme }) => theme.palette.divider};
    @media (max-width: 560px) {
      max-width: 90%;
      margin: 12px;
      overflow-y: visible;
    }
  }
`;

export const SignInSheet = styled("div")({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  textAlign: "center",
  gap: 8,
  padding: "8px 4px 0",
});

export const SignInTitle = styled("h2")({
  margin: 0,
  color: "black",
  fontFamily: "'Inter', sans-serif",
  fontSize: 24,
  fontWeight: 700,
  lineHeight: 1.25,
});

export const SignInBody = styled("p")({
  margin: "0 0 16px",
  color: "rgba(0, 0, 0, 0.6)",
  fontFamily: "'Inter', sans-serif",
  fontSize: 15,
  lineHeight: 1.5,
});

// The connect dialog's content box. The top padding clears the badge that IconContainer floats
// over the paper's top edge (it reaches ~56px into the card).
export const ConnectBody = styled(SignInSheet)({
  padding: "64px 24px 24px",
  "@media (max-width: 560px)": {
    padding: "60px 20px 20px",
  },
});

export const CircularIcon = styled("div")`
  background-color: ${({ theme }) => theme.palette.back.light};
  padding: 16px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 64px; /* Adjust the size as needed */
  height: 64px; /* Adjust the size as needed */
`;

export const IconContainer = styled("div")`
  padding: 16px;
  position: absolute;
  top: -40px;
  border-radius: 100%;
  background-color: #f2f2f2;
  left: 50%;
  transform: translateX(-50%);
`;
